import React, { Fragment, useEffect, useState } from "react";
import M from "materialize-css";
import Swal from "sweetalert2";
import Loader from "../../Components/Loader";

import { useAuth } from "../../Context/Context";

import icon2 from "../../Images/Icon/63.png";

import BanersHelper from "../../Helpers/Baners";

const View = () => {
  const { setEditar } = useAuth();

  const [baners, setBaners] = useState([]);
  const [flag, setFlag] = useState(false);
  const [estadoOfertaBaner, setEtadoOfertaBaner] = useState(false);
  const [estadoBaner, setEstadoBaner] = useState(false);
  const [fecha, setFecha] = useState("");
  const [color, setColor] = useState("");

  useEffect(() => {
    obtenerConfiguracionBaners();
  }, []);

  const obtenerConfiguracionBaners = async () => {
    let res = await BanersHelper.obtenerConfiguracionBaners();

    if (res.success) {
      setEtadoOfertaBaner(res.data.baner_oferta);
      setEstadoBaner(res.data.baners);
      setFecha(res.data.fecha);
      setColor(res.data.color);
      obtenerBaners();
    } else {
      Swal.fire(
        "Error!",
        "No se lograron obtener la configuracion de los baners, codigo: " +
          res.code,
        "error"
      );
    }
  };

  const obtenerBaners = async () => {
    let res = await BanersHelper.obtenerBaners();

    if (res.success) {
      setBaners(res.data);
      setFlag(true);

      setTimeout(() => {
        let elems = document.querySelectorAll(".datepicker");
        M.Datepicker.init(elems, {
          onSelect: (fecha) => {
            let fechaFin = new Date(
              fecha.getFullYear(),
              fecha.getMonth(),
              fecha.getDate(),
              17,
              59,
              0
            );

            setFecha(fechaFin);
          },
          defaultDate: new Date(),
          setDefaultDate: true,
        });
      }, 1000);
    } else {
      Swal.fire(
        "Error!",
        "No se lograron obtener los baners, codigo: " + res.code,
        "error"
      );
    }
  };

  const eliminarBaner = (id) => {
    BanersHelper.eliminarBaner(id);
  };

  const agregarBaner = () => {
    let ventana = document.getElementById("ventana_editable_agregar");
    ventana.className = "ventana_editable col s3";
    let vista = document.getElementById("vistas_generales");
    vista.className = "col s9";
    let cerrar = document.getElementById("invisible_cerrar_agregar");
    cerrar.className = "invisible_cerrar_activado";
  };

  const editarBaner = (etiqueta) => {
    let ventana = document.getElementById("ventana_editable_editar");
    ventana.className = "ventana_editable col s3";
    let vista = document.getElementById("vistas_generales");
    vista.className = "col s9";
    let cerrar = document.getElementById("invisible_cerrar");
    cerrar.className = "invisible_cerrar_activado";
    setEditar(etiqueta);
  };

  const activarOfertaRelampago = (e) => {
    if (estadoBaner) {
      return Swal.fire(
        "Error!",
        "Solo puedes tener un baner activo al mismo tiempo",
        "error"
      );
    }

    if (e.target.value === "false") {
      setEtadoOfertaBaner(true);
    } else {
      setEtadoOfertaBaner(false);
    }
  };

  const activarBaner = (e) => {
    if (estadoOfertaBaner) {
      return Swal.fire(
        "Error!",
        "Solo puedes tener un baner activo al mismo tiempo",
        "error"
      );
    }

    if (e.target.value === "false") {
      setEstadoBaner(true);
    } else {
      setEstadoBaner(false);
    }
  };

  const leerColor = (e) => {
    setColor(e.target.value);
  };

  const actualizarBaners = () => {
    let body = {
      baner_oferta: estadoOfertaBaner,
      baners: estadoBaner,
      fecha,
      color,
    };

    BanersHelper.editarConfiguracionBaner(body);
  };

  return (
    <div id="vistas_generales" className="col s12" style={{ padding: "0" }}>
      <div className="container center">
        {!flag ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "60vh",
            }}
          >
            <Loader />
          </div>
        ) : (
          <Fragment>
            <p className="titulo_solicitud" style={{ textAlign: "center" }}>
              Baner Oferta Relampago
            </p>

            <div
              className="row"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div className="col s4">
                <div class="switch">
                  <label>
                    Apagado
                    <input
                      value={estadoOfertaBaner}
                      checked={estadoOfertaBaner}
                      onChange={activarOfertaRelampago}
                      type="checkbox"
                    />
                    <span class="lever"></span>
                    Encendido
                  </label>
                </div>
              </div>
              <div className="col s4">
                <input
                  type="text"
                  class="datepicker"
                  value={new Date(fecha)}
                  placeholder="Fecha relampago"
                />
              </div>
              <div className="col s4">
                <p>
                  Color Baner y <br />
                  Oferta relampago
                </p>
                <input type="color" defaultValue={color} onChange={leerColor} />
              </div>
            </div>

            <div>
              <p style={{ marginLeft: "25px" }} className="texto_solicitud">
                Titulo
              </p>
              <div>
                {baners.map(
                  (etiqueta) =>
                    etiqueta.tipo === 2 && (
                      <div className="box_solicitud">
                        <div className="row">
                          <div className="col s10">
                            <div style={{ marginLeft: "25px" }} className="">
                              <p className="texto_solicitud">
                                {etiqueta.titulo}
                              </p>
                            </div>
                          </div>
                          <div className="col s2">
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                paddingRight: "25px",
                              }}
                            >
                              <img
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  eliminarBaner(etiqueta._id);
                                }}
                                src={icon2}
                                alt=""
                              />
                              <button
                                onClick={() => {
                                  editarBaner(etiqueta);
                                }}
                                className="caja_status"
                                style={{
                                  backgroundColor: "#00496C",
                                  border: "none",
                                }}
                              >
                                <p>EDITAR</p>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                )}
              </div>
            </div>
            <p className="titulo_solicitud" style={{ textAlign: "center" }}>
              Baners Genrales
            </p>
            <div class="switch">
              <label>
                Apagado
                <input
                  value={estadoBaner}
                  checked={estadoBaner}
                  onChange={activarBaner}
                  type="checkbox"
                />
                <span class="lever"></span>
                Encendido
              </label>
            </div>
            <div>
              <p style={{ marginLeft: "25px" }} className="texto_solicitud">
                Titulo
              </p>
              <div>
                {baners.map(
                  (etiqueta) =>
                    etiqueta.tipo === 1 && (
                      <div className="box_solicitud">
                        <div className="row">
                          <div className="col s10">
                            <div style={{ marginLeft: "25px" }} className="">
                              <p className="texto_solicitud">
                                {etiqueta.titulo}
                              </p>
                            </div>
                          </div>
                          <div className="col s2">
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                paddingRight: "25px",
                              }}
                            >
                              <img
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  eliminarBaner(etiqueta._id);
                                }}
                                src={icon2}
                                alt=""
                              />
                              <button
                                onClick={() => {
                                  editarBaner(etiqueta);
                                }}
                                className="caja_status"
                                style={{
                                  backgroundColor: "#00496C",
                                  border: "none",
                                }}
                              >
                                <p>EDITAR</p>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                )}
              </div>
            </div>
          </Fragment>
        )}
        <div style={{ display: "flex", justifyContent: "center", gap: "15px" }}>
          <div className="boton_2_nv">
            <button onClick={agregarBaner}>
              <p>Agregar baner</p>
            </button>
          </div>
          <div className="boton_2_nv">
            <button onClick={actualizarBaners}>
              <p>Actualizar baner</p>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default View;
